import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M41.182 9C43.29 9 45 10.699 45 12.794v22.412C45 37.3 43.29 39 41.182 39c-2.109 0-3.818-1.699-3.818-3.794V12.794C37.364 10.7 39.074 9 41.182 9Zm0 1.897c-1.055 0-1.91.85-1.91 1.897v22.412c0 1.047.855 1.897 1.91 1.897 1.054 0 1.909-.85 1.909-1.898v-22.41a1.903 1.903 0 0 0-1.91-1.898Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M25.91 20.318a3.818 3.818 0 1 1 7.635 0v14.864a3.818 3.818 0 0 1-7.636 0V20.318ZM18.273 24a3.818 3.818 0 0 0-3.819 3.818v7.364a3.818 3.818 0 0 0 7.637 0v-7.364A3.818 3.818 0 0 0 18.273 24ZM6.75 31.5a3.75 3.75 0 1 0 0 7.5h.136a3.75 3.75 0 1 0 0-7.5H6.75Z"
    }
  )
);
var SvgNetwork3Outlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var Network3Outlined_default = SvgNetwork3Outlined;

export { Network3Outlined_default as default };
